import { render } from "./SidebarItem.vue?vue&type=template&id=03caf25f"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=03caf25f&lang=css"
script.render = render

export default script